import React from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import {
  INQUIRY_STATUSES,
  INQUIRY_STATUS_LABELS,
} from '../../../../config/app.config';

export function InquiryStatusDropdown({
  currentStatus,
  onStatusChange,
  className,
}) {
  const isClosed =
    currentStatus === INQUIRY_STATUSES.CLOSED ||
    currentStatus === INQUIRY_STATUSES.CLOSED_AUTO;

  const label = INQUIRY_STATUS_LABELS[currentStatus] || currentStatus;

  if (isClosed) {
    return (
      <span className="inquiry-status-disabled">
        {label}
      </span>
    );
  }

  return (
    <UncontrolledDropdown className={className}>
      <DropdownToggle id="dropdown-toggle" caret>
        {label}
      </DropdownToggle>
      <DropdownMenu className="dropdown__menu">
        <DropdownItem
          tag="div"
          onClick={() => onStatusChange(INQUIRY_STATUSES.OPEN)}
        >
          <a
            style={{
              fontWeight:
                currentStatus === INQUIRY_STATUSES.OPEN ? '600' : '400',
            }}
          >
            {INQUIRY_STATUS_LABELS[INQUIRY_STATUSES.OPEN]}
          </a>
        </DropdownItem>
        <DropdownItem
          tag="div"
          onClick={() => onStatusChange(INQUIRY_STATUSES.CLOSED)}
        >
          <a>{INQUIRY_STATUS_LABELS[INQUIRY_STATUSES.CLOSED]}</a>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
